import Component from './message_queue_table.vue'
export default Component
